type LoginPreflight = { login?: unknown } | null | undefined;

/** A missing preflight must not block signup. The create mutation still rejects a duplicate. */
export const identifierIsAvailable = (userLoginPreflight: LoginPreflight): boolean =>
  userLoginPreflight == null || userLoginPreflight.login === null;

/**
 * Debounce an async check. A newer call resolves the previous promise as available
 * so Yup does not leave the form invalid while that promise is abandoned.
 */
export const debounceLatest = (
  callback: (value: string | undefined) => Promise<boolean>,
  delay: number,
) => {
  const pending: {
    timeoutId?: ReturnType<typeof setTimeout>;
    resolvePrevious?: (value: boolean) => void;
  } = {};

  return (value: string | undefined) =>
    new Promise<boolean>((resolve) => {
      if (pending.timeoutId) clearTimeout(pending.timeoutId);
      pending.resolvePrevious?.(true);
      pending.resolvePrevious = resolve;
      pending.timeoutId = setTimeout(() => {
        pending.resolvePrevious = undefined;
        callback(value).then(resolve, () => resolve(true));
      }, delay);
    });
};
